"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createShortcutHandler = createShortcutHandler;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _immutable = require("immutable");

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var classBlacklist = ['public-DraftEditor-content', 'form-control'];
var nodeBlackList = ['INPUT', 'TEXTAREA'];

function getIsBlacklisted(target) {
  if (!nodeBlackList.includes(target.nodeName)) {
    var isBlacklistedClass = (0, _toConsumableArray2.default)(target.classList).some(function (el) {
      return classBlacklist.includes(el);
    });

    if (!isBlacklistedClass) {
      return false;
    }
  }

  return true;
}

function createShortcutHandler() {
  var pressedKeys = (0, _immutable.Set)();

  for (var _len = arguments.length, passedInShortcuts = new Array(_len), _key = 0; _key < _len; _key++) {
    passedInShortcuts[_key] = arguments[_key];
  }

  var shortcuts = (0, _immutable.Set)(passedInShortcuts);

  function checkAndRunShortcuts() {
    shortcuts.forEach(function (shortcut) {
      return shortcut(pressedKeys);
    });
  }

  function handleProfileKeydown(_ref) {
    var keyCode = _ref.keyCode,
        target = _ref.target;

    if (getIsBlacklisted(target)) {
      pressedKeys = pressedKeys.clear();
      return false;
    }

    pressedKeys = pressedKeys.add(keyCode);
    checkAndRunShortcuts();
    return true;
  }

  function handleProfileKeyup(_ref2) {
    var keyCode = _ref2.keyCode,
        target = _ref2.target;

    if (getIsBlacklisted(target)) {
      pressedKeys = pressedKeys.clear();
      return false;
    }

    pressedKeys = pressedKeys.delete(keyCode);
    return true;
  }

  function clearPressedKeys() {
    pressedKeys = pressedKeys.clear();
  }

  function registerShortcut(shortcut) {
    shortcuts = shortcuts.add(shortcut);
  }

  function getShortcuts() {
    return shortcuts;
  }

  var handleKeyUp = (0, _debounce.default)(100, handleProfileKeyup);
  var handleKeyDown = (0, _debounce.default)(100, handleProfileKeydown);

  function initializeShortcutListener() {
    document.addEventListener('keyup', handleKeyUp);
    document.addEventListener('keydown', handleKeyDown);
    window.addEventListener('blur', clearPressedKeys);
  }

  function removeShortcutListener() {
    document.removeEventListener('keyup', handleKeyUp);
    document.removeEventListener('keydown', handleKeyDown);
    window.removeEventListener('blur', clearPressedKeys);
  }

  return {
    initializeShortcutListener: initializeShortcutListener,
    removeShortcutListener: removeShortcutListener,
    registerShortcut: registerShortcut,
    // used for unit tests
    getShortcuts: getShortcuts
  };
}